import { PropsWithChildren, ReactNode } from 'react';
import { Tooltip } from './Tooltip';

interface TableTooltipProps extends PropsWithChildren {
  tooltip: ReactNode;
}

export const TableTooltip = ({ children, tooltip }: TableTooltipProps) => (
  <Tooltip
    content={tooltip}
    TooltipTriggerProps={{ asChild: true }}
    TooltipContentProps={{
      className: 'bg-white text-primary',
      withArrow: true,
      TooltipArrowProps: { className: 'fill-white' },
    }}
  >
    {children}
  </Tooltip>
);
